webpackJsonp([35783957827783],{

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: gray;\n  margin-bottom: 0.6rem;\n  time {\n    font-size: 0.95rem;\n    @media (max-width: 700px) {\n      font-size: 0.8rem;\n    }\n  }\n  span {\n    @media (max-width: 700px) {\n      font-size: 1rem;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: gray;\n  margin-bottom: 0.6rem;\n  time {\n    font-size: 0.95rem;\n    @media (max-width: 700px) {\n      font-size: 0.8rem;\n    }\n  }\n  span {\n    @media (max-width: 700px) {\n      font-size: 1rem;\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TimeDiv = _styledComponents2.default.div(_templateObject);
	
	exports.default = function (_ref) {
	  var date = _ref.date;
	  return _react2.default.createElement(
	    TimeDiv,
	    null,
	    _react2.default.createElement(
	      'span',
	      { className: 'material-icons' },
	      'calendar_today'
	    ),
	    '\xA0',
	    _react2.default.createElement(
	      'time',
	      null,
	      date
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: 0.95rem;\n  padding: 0.6rem 0.4rem;\n  border: 5px solid ', ';\n  @media (max-width: 700px) {\n    font-size: 0.7rem;\n    border: 3px solid ', ';\n  }\n  align-self: flex-end;\n  text-decoration: none;\n  display: inline-block;\n  margin-bottom: 1rem;\n  /* font-weight: bold; */\n  color: ', ';\n  box-shadow: 0px 5px 5px -1px rgba(0, 0, 0, 0.5);\n  &:hover {\n    background-color: ', ';\n    color: white;\n    box-shadow: 0px 8px 10px -1px rgba(0, 0, 0, 0.5);\n  }\n  transition: 0.2s;\n'], ['\n  font-size: 0.95rem;\n  padding: 0.6rem 0.4rem;\n  border: 5px solid ', ';\n  @media (max-width: 700px) {\n    font-size: 0.7rem;\n    border: 3px solid ', ';\n  }\n  align-self: flex-end;\n  text-decoration: none;\n  display: inline-block;\n  margin-bottom: 1rem;\n  /* font-weight: bold; */\n  color: ', ';\n  box-shadow: 0px 5px 5px -1px rgba(0, 0, 0, 0.5);\n  &:hover {\n    background-color: ', ';\n    color: white;\n    box-shadow: 0px 8px 10px -1px rgba(0, 0, 0, 0.5);\n  }\n  transition: 0.2s;\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject, _colors.siteAccent, _colors.siteAccent, _colors.siteAccent, _colors.siteAccent);
	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  /* text-decoration: none; */\n  h1 {\n    line-height: 2rem;\n    border-bottom: 2px solid transparent;\n    margin-bottom: 0.8rem;\n    &:hover {\n      color: ', ';\n      border-bottom: 2px solid ', ';\n    }\n    transition: border-bottom 0.2s, color 0.2s;\n  }\n'], ['\n  /* text-decoration: none; */\n  h1 {\n    line-height: 2rem;\n    border-bottom: 2px solid transparent;\n    margin-bottom: 0.8rem;\n    &:hover {\n      color: ', ';\n      border-bottom: 2px solid ', ';\n    }\n    transition: border-bottom 0.2s, color 0.2s;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(12);
	
	var _Button = __webpack_require__(166);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Date = __webpack_require__(60);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PostLinkDiv = _styledComponents2.default.div(_templateObject);
	
	var TitleLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject2, _colors.siteAccent, _colors.siteAccent);
	
	exports.default = function (_ref) {
	  var post = _ref.post;
	  var _post$frontmatter = post.frontmatter,
	      path = _post$frontmatter.path,
	      title = _post$frontmatter.title,
	      date = _post$frontmatter.date;
	
	  console.log(post);
	  return _react2.default.createElement(
	    PostLinkDiv,
	    null,
	    _react2.default.createElement(
	      TitleLink,
	      { to: path },
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(_Date2.default, { date: date }),
	    _react2.default.createElement(
	      'p',
	      null,
	      post.excerpt
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { to: path },
	      'CONTINUE READING'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: gray;\n  width: 100%;\n  height: 2px;\n  margin-bottom: 1.5rem;\n'], ['\n  background-color: gray;\n  width: 100%;\n  height: 2px;\n  margin-bottom: 1.5rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = _styledComponents2.default.div(_templateObject);
	module.exports = exports['default'];

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  margin-bottom: 1rem;\n'], ['\n  text-align: center;\n  margin-bottom: 1rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = _styledComponents2.default.h1(_templateObject);
	module.exports = exports['default'];

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PostLink = __webpack_require__(167);
	
	var _PostLink2 = _interopRequireDefault(_PostLink);
	
	var _Line = __webpack_require__(169);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _SubHeader = __webpack_require__(31);
	
	var _SubHeader2 = _interopRequireDefault(_SubHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var edges = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _SubHeader2.default,
	      null,
	      'Articles'
	    ),
	    edges.map(function (edge) {
	      return [_react2.default.createElement(_PostLink2.default, { key: edge.node.id, post: edge.node }), _react2.default.createElement(_Line2.default, { key: 'line_' + edge.node.id })];
	    })
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f058da46fcf9e5731e24.js